'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jbone = require('jbone');

var _jbone2 = _interopRequireDefault(_jbone);

var _view = require('../../core/view');

var _view2 = _interopRequireDefault(_view);

var _progress = require('./progress.scss');

var _progress2 = _interopRequireDefault(_progress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgressView = function (_View) {
  _inherits(ProgressView, _View);

  function ProgressView(config) {
    _classCallCheck(this, ProgressView);

    var _this = _possibleConstructorReturn(this, (ProgressView.__proto__ || Object.getPrototypeOf(ProgressView)).call(this, config));

    var callbacks = config.callbacks;


    _this._callbacks = callbacks;
    _this.$node = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['seek-block'],
      'data-hook': 'progress-control'
    });

    _this.$played = (0, _jbone2.default)('<progress>', {
      class: _this.styleNames['progress-bar'] + ' ' + _this.styleNames['progress-played'],
      'data-hook': 'played-indicator',
      role: 'played',
      max: 100,
      value: 0
    });

    _this.$buffered = (0, _jbone2.default)('<progress>', {
      class: _this.styleNames['progress-bar'] + ' ' + _this.styleNames['progress-buffered'],
      'data-hook': 'buffered-indicator',
      role: 'buffered',
      max: 100,
      value: 0
    });

    _this.$input = (0, _jbone2.default)('<input>', {
      class: _this.styleNames['seek-control'],
      'data-hook': 'seek-input',
      type: 'range',
      min: 0,
      max: 100,
      step: 0.1,
      value: 0
    });

    _this.$node.append(_this.$buffered).append(_this.$played).append(_this.$input);

    _this._bindCallbacks();
    _this._bindEvents();
    return _this;
  }

  _createClass(ProgressView, [{
    key: '_onMouseInteractionStart',
    value: function _onMouseInteractionStart(e) {
      if (e.button > 1) {
        return;
      }

      this._callbacks.onUserInteractionStart();
    }
  }, {
    key: '_onMouseInteractionEnd',
    value: function _onMouseInteractionEnd(e) {
      if (e.button > 1) {
        return;
      }

      this._callbacks.onUserInteractionEnd();
    }
  }, {
    key: '_onInputValueChange',
    value: function _onInputValueChange() {
      var value = this.$input.val();
      this.$played.attr('value', value);
      this._callbacks.onChangePlayedProgress(value);
    }
  }, {
    key: '_bindCallbacks',
    value: function _bindCallbacks() {
      this._onMouseInteractionStart = this._onMouseInteractionStart.bind(this);
      this._onMouseInteractionEnd = this._onMouseInteractionEnd.bind(this);
      this._onInputValueChange = this._onInputValueChange.bind(this);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this.$input[0].addEventListener('input', this._onInputValueChange);
      this.$input[0].addEventListener('change', this._onInputValueChange);

      this.$node[0].addEventListener('mousedown', this._onMouseInteractionStart);
      this.$node[0].addEventListener('mouseup', this._onMouseInteractionEnd);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this.$input[0].removeEventListener('input', this._onInputValueChange);
      this.$input[0].removeEventListener('change', this._onInputValueChange);

      this.$node[0].removeEventListener('mousedown', this._onMouseInteractionStart);
      this.$node[0].removeEventListener('mouseup', this._onMouseInteractionEnd);
    }
  }, {
    key: '_updatePlayed',
    value: function _updatePlayed(percent) {
      this.$input.val(percent);
      this.$input.attr('value', percent);
      this.$played.attr('value', percent);
    }
  }, {
    key: '_updateBuffered',
    value: function _updateBuffered(percent) {
      this.$buffered.attr('value', percent);
    }
  }, {
    key: 'setState',
    value: function setState(_ref) {
      var played = _ref.played,
          buffered = _ref.buffered;

      played !== undefined && this._updatePlayed(played);
      buffered !== undefined && this._updateBuffered(buffered);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(this.styleNames.hidden, true);
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(this.styleNames.hidden, false);
    }
  }, {
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.$node.remove();

      delete this.$input;
      delete this.$played;
      delete this.$buffered;
      delete this.$node;
    }
  }]);

  return ProgressView;
}(_view2.default);

ProgressView.extendStyleNames(_progress2.default);

exports.default = ProgressView;
//# sourceMappingURL=progress.view.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/ui/controls/progress/progress.view.js
// module id = 1699
// module chunks = 1 2 3